/* Agus India theme */
(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const theme = window.theme || { routes: {}, strings: {} };

  /* Drawers ---------------------------------------------------------------- */
  let lastTrigger = null;
  function openDrawer(drawer, trigger) {
    if (!drawer) return;
    lastTrigger = trigger || document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('has-drawer-open');
    $$(`[aria-controls="${drawer.id}"]`).forEach((t) => t.setAttribute('aria-expanded', 'true'));
    const focusable = $('button, [href], input, select, textarea', $('.drawer__panel', drawer));
    if (focusable) setTimeout(() => focusable.focus(), 50);
  }
  function closeDrawer(drawer) {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) document.body.classList.remove('has-drawer-open');
    $$(`[aria-controls="${drawer.id}"]`).forEach((t) => t.setAttribute('aria-expanded', 'false'));
    if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(document.getElementById(opener.dataset.drawerOpen), opener);
      return;
    }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) closeDrawer(closer.closest('.drawer'));
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('.drawer.is-open').forEach(closeDrawer);
    $$('[data-nav-details][open]').forEach((d) => d.removeAttribute('open'));
  });

  /* Header: search + dropdowns ------------------------------------------------ */
  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-search-toggle]');
    if (toggle) {
      const panel = document.getElementById('HeaderSearch');
      if (!panel) return;
      e.preventDefault();
      panel.hidden = !panel.hidden;
      toggle.setAttribute('aria-expanded', String(!panel.hidden));
      if (!panel.hidden) $('input[type="search"]', panel).focus();
    }
    $$('[data-nav-details][open]').forEach((d) => {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });
  $$('[data-nav-details]').forEach((details) => {
    details.addEventListener('toggle', () => {
      if (!details.open) return;
      $$('[data-nav-details][open]').forEach((other) => other !== details && other.removeAttribute('open'));
    });
    if (window.matchMedia('(hover: hover)').matches) {
      details.addEventListener('mouseenter', () => details.setAttribute('open', ''));
      details.addEventListener('mouseleave', () => details.removeAttribute('open'));
    }
  });

  /* Rotators: announcement bar, testimonials, slideshow ------------------------- */
  function rotator(items, { onChange, interval } = {}) {
    let index = Math.max(0, items.findIndex((i) => i.classList.contains('is-active')));
    let timer = null;
    const go = (next) => {
      items[index].classList.remove('is-active');
      index = (next + items.length) % items.length;
      items[index].classList.add('is-active');
      if (onChange) onChange(index);
    };
    const start = () => {
      if (!interval || reducedMotion || items.length < 2) return;
      stop();
      timer = setInterval(() => go(index + 1), interval);
    };
    const stop = () => timer && clearInterval(timer);
    start();
    return { go: (n) => { go(n); start(); }, next: () => { go(index + 1); start(); }, prev: () => { go(index - 1); start(); }, start, stop, get index() { return index; } };
  }
  $$('[data-announcement]').forEach((bar) => {
    const items = $$('.announcement-bar__message', bar);
    if (items.length > 1) rotator(items, { interval: 5000 });
  });
  $$('[data-rotator]').forEach((root) => {
    const r = rotator($$('[data-rotator-item]', root));
    const prev = $('[data-rotator-prev]', root);
    const next = $('[data-rotator-next]', root);
    if (prev) prev.addEventListener('click', r.prev);
    if (next) next.addEventListener('click', r.next);
  });
  $$('[data-slideshow]').forEach((root) => {
    const slides = $$('[data-slide]', root);
    const dots = $$('[data-slide-to]', root);
    if (slides.length < 2) return;
    const autoplay = root.dataset.autoplay === 'true';
    const r = rotator(slides, {
      interval: autoplay ? Number(root.dataset.speed) || 7000 : 0,
      onChange: (i) => dots.forEach((d, n) => d.classList.toggle('is-active', n === i)),
    });
    dots.forEach((dot) => dot.addEventListener('click', () => r.go(Number(dot.dataset.slideTo))));
    root.addEventListener('mouseenter', r.stop);
    root.addEventListener('mouseleave', r.start);
    root.addEventListener('focusin', r.stop);
  });

  /* Cart -------------------------------------------------------------------- */
  const cartDrawer = () => document.getElementById('CartDrawer');
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
    });
  }
  function renderCartDrawer(html) {
    const drawer = cartDrawer();
    if (!drawer || !html) return;
    const fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('CartDrawer');
    if (fresh) drawer.innerHTML = fresh.innerHTML;
  }
  async function refreshCart(sections) {
    const res = await fetch(`${theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } });
    const cart = await res.json();
    updateCartCount(cart.item_count);
    if (sections && sections['cart-drawer']) renderCartDrawer(sections['cart-drawer']);
    return cart;
  }
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-cart-open]');
    if (!trigger || theme.cartType !== 'drawer' || !cartDrawer()) return;
    e.preventDefault();
    openDrawer(cartDrawer(), trigger);
  });
  async function changeLine(line, quantity) {
    const drawer = cartDrawer();
    if (drawer) drawer.classList.add('is-loading');
    try {
      const res = await fetch(`${theme.routes.cart_change_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: ['cart-drawer'], sections_url: window.location.pathname }),
      });
      const data = await res.json();
      if (data.status) throw new Error(data.description || data.message);
      updateCartCount(data.item_count);
      renderCartDrawer(data.sections && data.sections['cart-drawer']);
    } catch (err) {
      alert(err.message || theme.strings.cartError);
    } finally {
      if (cartDrawer()) cartDrawer().classList.remove('is-loading');
    }
  }
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-cart-line]');
    if (!btn || !btn.closest('#CartDrawer')) return;
    e.preventDefault();
    changeLine(Number(btn.dataset.cartLine), Number(btn.dataset.quantity));
  });

  /* Product form ------------------------------------------------------------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form || theme.cartType !== 'drawer' || !cartDrawer()) return;
    if (e.submitter && e.submitter.hasAttribute('formaction')) return;
    e.preventDefault();
    const button = $('[type="submit"]', form);
    const errorBox = $('[data-form-error]', form.closest('[data-product]') || form);
    if (button) button.setAttribute('aria-disabled', 'true');
    if (errorBox) errorBox.hidden = true;
    try {
      const body = new FormData(form);
      body.append('sections', 'cart-drawer');
      body.append('sections_url', window.location.pathname);
      const res = await fetch(`${theme.routes.cart_add_url}.js`, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body });
      const data = await res.json();
      if (data.status) throw new Error(data.description || data.message);
      await refreshCart(data.sections);
      openDrawer(cartDrawer(), button);
    } catch (err) {
      if (errorBox) {
        errorBox.textContent = err.message || theme.strings.cartError;
        errorBox.hidden = false;
      } else {
        alert(err.message || theme.strings.cartError);
      }
    } finally {
      if (button) button.removeAttribute('aria-disabled');
    }
  });

  /* Quantity inputs ------------------------------------------------------------ */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty]');
    if (!btn) return;
    const input = $('input', btn.closest('.quantity'));
    if (!input) return;
    const min = Number(input.min) || 1;
    input.value = Math.max(min, (Number(input.value) || min) + Number(btn.dataset.qty));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Variant picker ---------------------------------------------------------------- */
  $$('[data-product]').forEach((root) => {
    const dataEl = $('[data-product-json]', root);
    if (!dataEl) return;
    const variants = JSON.parse(dataEl.textContent);
    const idInput = $('input[name="id"]', root);
    const sectionId = root.dataset.sectionId;
    const url = root.dataset.url;
    root.addEventListener('change', async (e) => {
      if (!e.target.closest('[data-option]')) return;
      const selected = $$('[data-option]', root).map((field) =>
        field.tagName === 'SELECT' ? field.value : ($('input:checked', field) || {}).value
      );
      const variant = variants.find((v) => v.options.every((opt, i) => opt === selected[i]));
      const button = $('[data-add-button]', root);
      if (!variant) {
        if (button) { button.disabled = true; button.textContent = theme.strings.unavailable; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (variant.featured_media) {
        const thumb = $(`[data-media-thumb="${variant.featured_media.id}"]`, root);
        if (thumb) thumb.click();
      }
      window.history.replaceState({}, '', `${url}?variant=${variant.id}`);
      try {
        const res = await fetch(`${url}?variant=${variant.id}&section_id=${sectionId}`);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        ['[data-price]', '[data-sku]', '[data-buy-area]'].forEach((sel) => {
          const fresh = $(sel, doc);
          const current = $(sel, root);
          if (fresh && current) current.innerHTML = fresh.innerHTML;
        });
      } catch (err) {
        /* keep the current markup if the refresh fails */
      }
    });
  });

  /* Product gallery ------------------------------------------------------------ */
  document.addEventListener('click', (e) => {
    const thumb = e.target.closest('[data-media-thumb]');
    if (!thumb) return;
    const gallery = thumb.closest('[data-gallery]');
    $$('[data-media-item]', gallery).forEach((item) => {
      item.hidden = item.dataset.mediaItem !== thumb.dataset.mediaThumb;
    });
    $$('[data-media-thumb]', gallery).forEach((t) => t.setAttribute('aria-current', String(t === thumb)));
  });

  /* Collection filters ----------------------------------------------------------- */
  $$('[data-facets-form]').forEach((form) => {
    form.addEventListener('change', () => form.requestSubmit ? form.requestSubmit() : form.submit());
  });

  /* Product recommendations -------------------------------------------------------- */
  $$('[data-recommendations]').forEach(async (el) => {
    try {
      const res = await fetch(el.dataset.url);
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const fresh = $('[data-recommendations]', doc);
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    } catch (err) {
      /* recommendations are optional */
    }
  });
})();
